module.exports = __webpack_public_path__ + "static/axiforma-bold-webfont-c070f057ea9914f22f80f9d9c2f9864b.woff2";